import { apiRequest } from './axiosConfig';

/** 1 スタイルで作ったバナーのうち、各反応があった枚数 */
export interface StyleQualityCounts {
  detail_opened: number;
  downloaded: number;
  favorited: number;
  resized: number;
  edited: number;
  regenerated: number;
  deleted: number;
  clef_evaluated: number;
  clef_passed: number;
}

/** 全体平均へ寄せた後の率（0〜1）。Clef 判定が 1 件も無ければ clef_pass は null */
export interface StyleQualityRates {
  positive: number;
  detail: number;
  negative: number;
  clef_pass: number | null;
}

export type StyleQualityCandidateReason = 'low_total' | 'low_clef';

export interface StyleQualityRow {
  style_id: number;
  name: string;
  category: string | null;
  thumbnail_url: string | null;
  is_active: boolean;
  sample_size: number;
  counts: StyleQualityCounts;
  rates: StyleQualityRates;
  /** 0〜100。全体平均が 50 */
  scores: { behavior: number; clef: number; total: number };
  /** Clef 不合格の理由ごとの枚数（多い順）。1 枚で複数の理由に数えることがある */
  clef_failed_checks: { check: string; count: number }[];
  is_hide_candidate: boolean;
  candidate_reasons: StyleQualityCandidateReason[];
}

export interface StyleQualitySettings {
  min_samples: number;
  total_threshold: number;
  clef_pass_threshold: number;
  clef_min_evaluated: number;
  prior_weight: number;
}

export interface StyleQualityData {
  days: number;
  settings: StyleQualitySettings;
  global: {
    sample_size: number;
    styles: number;
    rates: StyleQualityRates;
  };
  /** 総合点の低い順 */
  styles: StyleQualityRow[];
}

/** 1 枚のバナーへの反応（そのバナーで 1 回でもあれば true） */
export interface StyleQualitySampleReactions {
  detail_opened: boolean;
  downloaded: boolean;
  favorited: boolean;
  resized: boolean;
  edited: boolean;
  regenerated: boolean;
  style_good: boolean;
  style_bad: boolean;
}

export interface StyleQualitySample {
  id: number;
  image_url: string;
  thumbnail_url: string | null;
  created_at: string | null;
  generation_source: string | null;
  product: { id: number; name: string; url: string | null } | null;
  organization_name: string | null;
  reactions: StyleQualitySampleReactions;
  /** Clef 未判定なら null */
  clef_passed: boolean | null;
  /** 不合格の理由。score は「問題がある」確率（0〜1、しきい値以上で不合格） */
  clef_failed_checks: { check: string; score: number | null }[];
}

/** 点数の根拠になったバナー（新しい順・残っている画像だけ） */
export interface StyleQualitySamplesPage {
  total: number;
  page: number;
  per_page: number;
  last_page: number;
  items: StyleQualitySample[];
}

const adminStyleQualityService = {
  async list(days: number): Promise<StyleQualityData> {
    const response = await apiRequest.get<{
      success: boolean;
      data: StyleQualityData;
    }>('admin/image-styles/quality-scores', { params: { days } });
    return response.data;
  },

  async samples(styleId: number, days: number, page: number): Promise<StyleQualitySamplesPage> {
    const response = await apiRequest.get<{
      success: boolean;
      data: StyleQualitySamplesPage;
    }>(`admin/image-styles/${styleId}/quality-samples`, {
      params: { days, page },
    });
    return response.data;
  },
};

export default adminStyleQualityService;
